<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-7"></a>
<h2 class="fm-head1">Author’s Note</h2>
<p class="nonindent">Quotations from primary source material have retained their original spelling and grammar where applicable. To the best of the author’s knowledge and ability dates within this book are in line with the Julian calendar, which was the calendar in use in seventeenth-century England and at the time was roughly 10 days behind the present-day Gregorian calendar. The Gregorian calendar was adopted in England in 1752. All years (again to the best of the author’s knowledge and ability) are presented as beginning on 1 January, although in the 1600s it was common to celebrate the New Year on 25 March.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_FM1.vue?76d44ea6